import { LocationDocument } from "@onpreo/database";

export type LocationsState = {
    locations: LocationDocument[];
};
export const initialLocationsState = {
    locations: []
};
